import React from 'react';

// Icons
import { TicketIcon } from '../Icons';

// Components
import StrapiDescription from '../StrapiDescription';
import { ArrowLink } from '../common';

// Models
import { IEvent } from '../../utils/models';

// Hooks
import { useVisitId } from '../../hooks/useVisitId';
import useContextToken from '../../hooks/useContextToken';

import './EventDetails.scss';

export interface IEventDetailsProps {
  event: IEvent;
}

const EventDetails = ({
  event: { description, payPerView },
}: IEventDetailsProps) => {
  const visitId = useVisitId();
  const { contextToken } = useContextToken();

  return (
    <section className="event-details">
      <h2 className="event-details__title">Details</h2>
      <hr className="page__divider" aria-hidden={true} />

      {payPerView && (
        <p className="ppv">
          <TicketIcon className="ppv__icon" />
          <span className="ppv__text">This is a Pay-Per-View Event</span>
          <ArrowLink
            text="Learn More"
            path={`https://www.spectrum.net/support/tv/spectrum-pay-view-events?cmp=sod_ppv_learnmore&visitId=${visitId}${contextToken}`}
            rel="noreferrer"
            target="_blank"
            tealiumConfig={{
              dataLinkType: 'arrow-link',
              dataLinkName: 'Event Learn More',
            }}
          />
        </p>
      )}

      {description && (
        <StrapiDescription
          className="event-details__description"
          description={description}
        />
      )}
    </section>
  );
};

export default EventDetails;
